module.exports = __webpack_public_path__ + "img/contact_inner2-2.6cb51644.png";